export default __webpack_public_path__ + "static/exotic_1-0a287c99cfa353dbb4a176c71f305101.webp";